var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuperCoin = function SvgSuperCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC30D",
    d: "M14.01 9.207c0 3.36-2.69 5.92-6.01 5.92s-6.008-2.56-6.008-5.92 2.69-6.083 6.009-6.083c3.318 0 6.01 2.725 6.01 6.083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD0",
    d: "M8 16c-4.486 0-8-3.472-8-7.903C0 3.633 3.589 0 8 0s8 3.633 8 8.097C16 12.528 12.486 16 8 16"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "superCoin_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 16c-4.486 0-8-3.472-8-7.903C0 3.633 3.589 0 8 0s8 3.633 8 8.097C16 12.528 12.486 16 8 16"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#superCoin_svg__a)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 1.59c-3.707 0-6.722 3.053-6.722 6.805 0 3.7 2.954 6.6 6.722 6.6s6.722-2.898 6.722-6.6c0-3.752-3.015-6.804-6.722-6.804"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0A700",
    d: "M8.055 1.224c-3.707 0-6.722 3.052-6.722 6.804 0 3.7 2.954 6.6 6.722 6.6s6.722-2.9 6.722-6.6c.002-3.752-3.014-6.804-6.722-6.804"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC000",
    d: "M7.999 1.468c-3.707 0-6.722 3.052-6.722 6.804 0 3.7 2.953 6.6 6.722 6.6 3.768 0 6.722-2.9 6.722-6.6 0-3.752-3.016-6.804-6.722-6.804"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "superCoin_svg__b",
    width: 14,
    height: 14,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.999 1.468c-3.707 0-6.722 3.052-6.722 6.804 0 3.7 2.953 6.6 6.722 6.6 3.768 0 6.722-2.9 6.722-6.6 0-3.752-3.016-6.804-6.722-6.804"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#superCoin_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD60D",
    fillRule: "evenodd",
    d: "m10.4.695 5.027 5.09a3.25 3.25 0 0 1 0 4.558l-5.03 5.09a3.155 3.155 0 0 1-4.502 0l-5.03-5.09a3.25 3.25 0 0 1 0-4.558l5.03-5.09a3.157 3.157 0 0 1 4.505 0M6.947 14.38c2.57-2.878 5.326-5.958 5.326-5.958.602-.674.07-1.676-.89-1.674H8.411c-.176 0-.312-.117-.337-.263l.322-1.112c.309-1.065.746-2.572 1.046-3.621L3.96 7.857c-.497.67.03 1.598.953 1.598h2.97c.176 0 .313.117.337.263-.17.588-.813 2.952-1.274 4.663",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B110",
    d: "M4.914 9.452c-.923 0-1.45-.929-.953-1.598l.424-.473c.646-.72 3.47-3.861 5.057-5.631-.44 1.541-1.177 4.071-1.367 4.733.024.146.16.263.336.263h2.97c3.399 0 3.91 3.122 1.71 5.962l2.335-2.363a3.25 3.25 0 0 0 0-4.558L10.401.695a3.157 3.157 0 0 0-4.505 0L3.481 3.14C.84 5.812 1.457 9.452 4.914 9.452",
    opacity: 0.91
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D89309",
    fillRule: "evenodd",
    d: "M1.375 8.129c-.019 3.748 2.967 6.802 6.67 6.82.899.003 1.79-.179 2.616-.532 3.42-1.456 5.027-5.443 3.588-8.905-1.046-2.494-3.458-4.12-6.135-4.134-3.703-.019-6.72 3.003-6.739 6.751M3.39 3.46a6.5 6.5 0 0 1 4.656-1.945c1.76 0 3.411.688 4.656 1.944a6.63 6.63 0 0 1 1.928 4.697 6.63 6.63 0 0 1-1.928 4.697A6.5 6.5 0 0 1 8.044 14.8a6.5 6.5 0 0 1-4.656-1.946A6.64 6.64 0 0 1 1.46 8.156c0-1.774.686-3.44 1.928-4.696",
    clipRule: "evenodd",
    opacity: 0.72
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.444 1.75 4.122 7.637c-.686.758-.282 1.828.732 1.802l3.072.028a.28.28 0 0 1 .278.286q0 .036-.01.074l-1.233 4.559 5.28-5.794c.662-.726.154-1.903-.824-1.903l-3.03.057a.28.28 0 0 1-.275-.363c.324-1.15 1.291-4.591 1.332-4.633"
  })));
};
export default SvgSuperCoin;